import { SystemService } from '@core/services/system/system.service';

import { Injectable, effect } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CustomTitleService extends TitleStrategy {
  empresa: string;

  constructor(
    private title: Title,
    private systemService: SystemService
  ) {
    super();

    effect(() => {
      const config = this.systemService.configuracao();
      this.empresa = config?.nomeSoftware;
    });
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    let env = '';
    if (!environment.production) {
      env = ` - Homologa`;
    }
    const newTitle = this.buildTitle(snapshot);
    if (newTitle) {
      this.title.setTitle(`${this.empresa} ${env} - ${newTitle}`);
    }
  }
}
